import React, { FC, MouseEventHandler, useCallback } from 'react';
import { TableCell, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { IStoreySum } from '@shared/helpers/storeys.helpers';

interface CalculationVariableProps {
  storeySumExpressionVariablesSum: IStoreySum;
  variable: string;
  activeVariable: string | undefined;
  setActiveVariable: (variable: string | undefined) => void;
}

const CalculationVariable: FC<CalculationVariableProps> = ({
  storeySumExpressionVariablesSum,
  variable,
  activeVariable,
  setActiveVariable,
}) => {
  const { classes, cx } = useStyles();

  const onMouseEnter: MouseEventHandler<HTMLSpanElement> = useCallback(
    (event) => {
      const variable = event.currentTarget.dataset.variable;
      if (!variable) {
        return;
      }
      setActiveVariable(variable);
    },
    [setActiveVariable],
  );
  const onMouseLeave = useCallback(
    () => setActiveVariable(undefined),
    [setActiveVariable],
  );

  return (
    <TableCell
      data-variable={variable}
      className={cx(
        classes.cell,
        variable === activeVariable && classes.cellActive,
        storeySumExpressionVariablesSum[variable as keyof IStoreySum] !==
          undefined && classes.cellReal,
      )}
      component="th"
      scope="row"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {variable}
    </TableCell>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  cell: { border: 0 },
  cellActive: { textShadow: `0 0 1px ${theme.palette.text.primary}` },
  cellReal: { fontWeight: 700 },
}));

export default CalculationVariable;
